import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { TimeRecord } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  saveTimeRecord(request: Boundaries["saveTimeRecord"]["request"]): void;
}

function useSaveTimeRecord(timeRecord: TimeRecord): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isSaveTimeRecordRequestPending(timeRecord),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isSaveTimeRecordRequestSuccess(timeRecord),
    ),
    isRequestFailure: useSelector(() =>
      selector.isSaveTimeRecordRequestFailure(timeRecord),
    ),
    saveTimeRecord: core.saveTimeRecord,
  };
}

export { useSaveTimeRecord };
